import React from 'react';
import { useTranslation } from 'react-i18next';
import { TireItem } from '@1po/1po-bff-fe-spec/generated/tire/model/TireItem';
import { DataContainer } from 'components/DataContainer';
import { LIFECYCLE_W2, LIFECYCLE_W3 } from 'domains/catalog/Catalog.types';
import { SparePartsViewType } from 'domains/user';
import { BorderedBox } from 'pages/CatalogPage/DH/Product/Product.styled';
import { TireReferenceCardsContainer } from 'pages/TiresPage/TireReferencesSection/TireReferencesContainer/TireReferenceCardsContainer';
import { Flex, MarginBox } from 'UI';

import type { SEARCH_STATUS } from 'utils';

export type SearchStatus = SEARCH_STATUS | undefined;

interface ReplacementProductsPanelProps {
  visible: boolean;
  replacementTiresFound?: TireItem[];
  searchStatus?: SearchStatus;
  sparePartsView: SparePartsViewType;
  isAvailableSoon: boolean;
  isNoLongerAvailable: boolean;
}

export const ReplacementProductsPanel = ({
  visible,
  replacementTiresFound,
  searchStatus,
  sparePartsView,
  isAvailableSoon,
  isNoLongerAvailable,
}: ReplacementProductsPanelProps) => {
  const { t } = useTranslation();

  if (!visible) return null;

  const tires =
    replacementTiresFound
      ?.filter((tire) => tire.lifeCycle === LIFECYCLE_W2 || tire.lifeCycle === LIFECYCLE_W3)
      .sort((a, b) => {
        const aBrand = a.brandName ?? '';
        const bBrand = b.brandName ?? '';
        return aBrand.localeCompare(bBrand);
      }) ?? [];

  const eligibleReplacementsCount = tires.length;

  const title =
    eligibleReplacementsCount === 0
      ? t('catalog.search.iam.no_replacements_found', 'No replacements found')
      : t('catalog.search.iam.replacement_products_other', 'Replacement products ({{count}})', {
          count: eligibleReplacementsCount,
        });

  return (
    <Flex direction={['column', 'row']} justify="center">
      <BorderedBox>
        <MarginBox>
          <DataContainer data={searchStatus}>
            <TireReferenceCardsContainer
              title={title}
              tires={tires}
              sparePartsView={sparePartsView}
              singleSection={eligibleReplacementsCount === 0}
              isAvailableSoon={isAvailableSoon}
              isNoLongerAvailable={isNoLongerAvailable}
              initShowCount={5}
              open={false}
              compact
            />
          </DataContainer>
        </MarginBox>
      </BorderedBox>
    </Flex>
  );
};
